export type GastrohubLocation = {
    id: number;
    name: string;
};

const types = {
    ACCESS_DESTROY_FAILED: "GASTROHUBPERMISSION/ACCESS_DESTROY_FAILED",
    ACCESS_DESTROY_REQUEST: "GASTROHUBPERMISSION/ACCESS_DESTROY_REQUEST",
    ACCESS_DESTROY_SUCCESS: "GASTROHUBPERMISSION/ACCESS_DESTROY_SUCCESS",

    ACCESS_FETCH_FAILED: "GASTROHUBPERMISSION/ACCESS_FETCH_FAILED",
    ACCESS_FETCH_REQUEST: "GASTROHUBPERMISSION/ACCESS_FETCH_REQUEST",
    ACCESS_FETCH_SUCCESS: "GASTROHUBPERMISSION/ACCESS_FETCH_SUCCESS",

    ACCESS_UPDATE_FAILED: "GASTROHUBPERMISSION/ACCESS_UPDATE_FAILED",
    ACCESS_UPDATE_REQUEST: "GASTROHUBPERMISSION/ACCESS_UPDATE_REQUEST",
    ACCESS_UPDATE_SUCCESS: "GASTROHUBPERMISSION/ACCESS_UPDATE_SUCCESS",

    LOCATIONS_FETCH_FAILED: "GASTROHUBPERMISSION/LOCATIONS_FETCH_FAILED",
    LOCATIONS_FETCH_REQUEST: "GASTROHUBPERMISSION/LOCATIONS_FETCH_REQUEST",
    LOCATIONS_FETCH_SUCCESS: "GASTROHUBPERMISSION/LOCATIONS_FETCH_SUCCESS",

    LOCATIONS_ROLES_FAILED: "GASTROHUBPERMISSION/LOCATIONS_ROLES_FAILED",
    LOCATIONS_ROLES_REQUEST: "GASTROHUBPERMISSION/LOCATIONS_ROLES_REQUEST",
    LOCATIONS_ROLES_SUCCESS: "GASTROHUBPERMISSION/LOCATIONS_ROLES_SUCCESS",
};

export default types;
